/**
 * The turn that starts a case: the engine reads the documents and runs from intake. With a target
 * (the SCN the reply answers) and in a Matter, it names both, as the backend's MATTER_RULES expect.
 * A Matter draft with nothing to name still gets the Matter sentence.
 */
export interface Named { label: string; name: string }

export const startMessage = (filenames: string[], target?: string, matter?: boolean, selected?: Named[]) => {
  // A draft that starts from a Matter may bring no uploads of its own: no "Uploaded documents: ." then.
  const uploaded = filenames.length ? ` Uploaded documents: ${filenames.join(", ")}.` : ""
  // The documents the reader chose, in the order to read them: the notice, then each reply by date, the hearing record.
  const using = selected?.length ? ` Use these documents, in this order: ${selected.map((d) => `${d.label}: ${d.name}`).join("; ")}.` : ""
  const rule = matter ? " Matter files: use list_documents." : ""
  if (!target) return `Start the OIO simulation.${using}${uploaded}${rule}`
  return `Start the OIO simulation. This reply answers the SCN: ${target}.${using}${uploaded}${rule}`
}
/** The thread id is already a UUID, which the backend requires for request_id. Deterministic, so a retry is idempotent. */
export const startRequestId = (threadId: string) => threadId
